import { render, staticRenderFns } from "./FuelStorageOrderView.vue?vue&type=template&id=5c2a2e94&"
import script from "./FuelStorageOrderView.vue?vue&type=script&lang=js&"
export * from "./FuelStorageOrderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports